import { Link as BaseLink } from 'react-router-dom';
import styled from 'styled-components';
import { space } from 'styled-system';

export default styled(BaseLink)`
  ${space}
  color: ${props => props.theme.enigmaBlue};
  text-decoration: none;
`;
